import { render, staticRenderFns } from "./residents-current.vue?vue&type=template&id=4407cc0a&scoped=true"
import script from "./residents-current.vue?vue&type=script&lang=js"
export * from "./residents-current.vue?vue&type=script&lang=js"
import style0 from "./residents-current.vue?vue&type=style&index=0&id=4407cc0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4407cc0a",
  null
  
)

export default component.exports